var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicePenetration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    rx: 4,
    fill: "#0C8CE9",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0312 17.1094L18.7812 19.7344L13.5312 19.4062L12.2188 20.3906L10.5781 18.75L11.9858 17.3423L13.5312 15.7969H18.125V17.1094L18.7812 17.7656L23.0272 16.0659L23.7031 15.7969L24.0312 17.1094Z",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 17.1094H15.5",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 20.3906L13.2031 21.375L12.2188 22.3594L8.28125 18.4219L9.26562 17.4375L10.5781 18.75",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 22.3594L10.9062 23.6719L6.96875 19.7344L8.28125 18.4219",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.4844C18.5807 14.4844 21.0781 11.987 21.0781 8.90625C21.0781 5.82554 18.5807 3.32812 15.5 3.32812C12.4193 3.32812 9.92188 5.82554 9.92188 8.90625C9.92188 11.987 12.4193 14.4844 15.5 14.4844Z",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4531 15.1337C19.6315 14.5748 20.6271 13.6928 21.3241 12.5905C22.0211 11.4881 22.391 10.2105 22.3906 8.90625",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 8.90625C8.60917 10.2104 8.97906 11.4878 9.67607 12.5901C10.3731 13.6923 11.3686 14.5742 12.5469 15.1331",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4814 16.4531C20.8548 15.7284 22.0043 14.6425 22.806 13.3126C23.6077 11.9826 24.0312 10.4591 24.0309 8.90625",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 8.90625C6.96848 10.4592 7.39209 11.9828 8.19392 13.3127C8.99575 14.6426 10.1454 15.7284 11.5189 16.4531",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.1719C17.8558 13.1719 19.7656 11.2621 19.7656 8.90625C19.7656 6.55041 17.8558 4.64062 15.5 4.64062C13.1442 4.64062 11.2344 6.55041 11.2344 8.90625C11.2344 11.2621 13.1442 13.1719 15.5 13.1719Z",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8594 7.26562H15.5C15.7611 7.26562 16.0115 7.36934 16.1961 7.55394C16.3807 7.73855 16.4844 7.98893 16.4844 8.25C16.4844 8.51107 16.3807 8.76145 16.1961 8.94606C16.0115 9.13066 15.7611 9.23437 15.5 9.23438H14.1875L16.1562 11.2031",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 7.26562H17.1406",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8594 8.25H17.1406",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.64062V3.32812",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.4844V13.1719",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7656 8.90625H21.0781",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92188 8.90625H11.2344",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5166 11.9219L19.4449 12.8501",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5557 4.96094L12.4839 5.8892",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5166 5.8892L19.4449 4.96094",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5557 12.8501L12.4839 11.9219",
    stroke: "#197BC2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePenetration);
export default __webpack_public_path__ + "static/media/Service_Penetration.fe8fe0da5c4c8b646b9b9ed570abbddd.svg";
export { ForwardRef as ReactComponent };